import axios from 'axios'

import { useGlobalDataStore } from '@stores/globalData/globalData.store'

import type { BackendModule, InitOptions, ReadCallback, Services } from 'i18next'

/**
 * Initialize i18n to map how our asset manifest grabs translation JSON.
 * This class is similar to what i18n-http-backend does
 *  but with custom behavior for our webpack hashing implementation
 *
 * BackendModule relies on ReactSuspense for asynchronous translation loading.
 */
export default class AssetBackend implements BackendModule {
  type: 'backend' = 'backend' as const
  static type: 'backend'

  init(_services: Services, _backendOptions: object, _i18nextOptions: InitOptions): void {
    // Does nothing
  }

  // given a language and a namespace, find which file to reading translations from
  read(language: string, namespace: string, callback: ReadCallback): void {
    this.fetchLocaleJSON(language, namespace, callback)
  }

  // Tells the class which JSON file to use, grabbing the file name from the manifest
  // then makes a request to S3 (or locally on dev)
  private async fetchLocaleJSON(
    language: string,
    namespace: string,
    callback: ReadCallback
  ): Promise<void> {
    const { assetManifest, serverData } = useGlobalDataStore.getState()
    if (!assetManifest) {
      callback(new Error('Missing asset manifest'), null)
      return
    }

    try {
      const assetUrl = assetManifest[`locales/${language}.json`]
      if (assetUrl && serverData) {
        const { data } = await axios.get(`${serverData.assetPath}/client/${assetUrl}`)
        callback(null, data)
      } else {
        callback(null, null)
      }
    } catch (err) {
      callback(err as any, null)
    }
  }
}
AssetBackend.type = 'backend'
